import {menu} from "@/assets/data/left_menu";

export default defineNuxtRouteMiddleware( async (to, from) => {
    menu.some((item)=>{
        let mi: any = null

        item.items.some((x)=> {
            mi = x.items.find((y: any) => to.fullPath.includes(y.route))

            if (mi) {
                return true
            }
        })

        if(mi) {
            useHead({
                title: mi.title
            })

            return true
        }
    })
})
